<template>
  <div class="bd">
    <div class="container">
      <div class="title" v-if="item.Software">
        <el-button size="medium" style="margin-right:7px;position:relative;top:-4px;" @click="$router.back()">
          <i class="fa fa-chevron-left fa-fw"></i>
        </el-button>
        {{item.Software.Name}} {{ item.Version }}
      </div>
      <el-row class="detail">
        <el-col :span="12">
          <div class="info">
            <span>版本号:</span>
            <span class="word">{{ item.Version }}</span>
          </div>
          <div class="info">
            <span>包含功能版本:</span>
            <span class="word">
              <el-tag
                v-for="basics in item.Basics"
                :key="basics.ID"
                type="success"
                style="margin-right:5px;font-size:14px;"
              >{{basics.Name}}</el-tag>
            </span>
          </div>
          <div class="info" v-if="item.MiniNet">
            <span>最低.Net FW版本:</span>
            <span class="word">{{ item.MiniNet.Name }}</span>
          </div>
          <div class="info" v-if="item.MiniSystem">
            <span>最低操作系统:</span>
            <span class="word">{{ item.MiniSystem.Name }}</span>
          </div>
          <div class="info" v-if="item.PublishDay">
            <span>发布日期:</span>
            <span class="word">{{ item.PublishDay.substring(0,10) }}</span>
          </div>
        </el-col>
        <el-col :span="12" v-if="item.Attachments">
          <div class="info">附件:</div>
          <div v-for="attachment in item.Attachments" :key="attachment.Url" class="info">
            <a
              :href="attachment.Url"
              :download="attachment.Name"
              style="color:#409eff;"
            >{{ attachment.Name }}</a>
          </div>
        </el-col>
      </el-row>
      <div class="sp-line">更新日志</div>
      <div v-html="item.UpdateLog" style="padding:30px;"></div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      item: {},
    };
  },
  created() {
    this.getItemData();
  },
  methods: {
    getItemData() {
      this.$axios.get(`software/version/${this.$route.params.ID}/visual`, {
        params: {
          with: ['Software', 'MiniNet', 'MiniSystem'],
        },
      }).then((response) => {
        this.item = response.data;
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.bd {
  min-height: 100vh;
  background-color: #fff;
}
.container {
  width: 1200px;
  margin: 0 auto;
  font-size: 16px;
  color: #303133;
}
.title {
  font-size: 28px;
  font-weight: 600;
  padding: 30px 0px 10px 0px;
}
.detail {
  margin-top: 15px;
  margin-bottom: 40px;
  padding: 15px 30px;
  border: 1px solid #409eff;
}
.info {
  margin-bottom: 10px;
  color: #606266;
}
.sp-line {
  font-size: 20px;
  font-weight: 600;
  padding: 0 20px;
  line-height: 1px;
  border-left: 540px solid #ccc;
  border-right: 540px solid #ccc;
  text-align: center;
}
.word {
  margin-left: 7px;
  color: #303133;
}
</style>
